var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.243 0.299 23.164 20.7",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".basket_svg__st1{fill:currentColor;stroke:currentColor;stroke-width:.6214;stroke-miterlimit:10}.basket_svg__st2{font-family:'MyriadPro-Bold'}.basket_svg__st3{font-size:9.1465px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "basket_svg__st1",
    d: "M23.069 3.899c-.3-.3-.7-.5-1.2-.5h-14.6c-.2 0-.4.2-.4.4s.2.4.4.4h14.7c.2 0 .4.1.5.2.1.1.2.3.2.5l-1.5 6.2c-.1.5-.5.9-1.1.9h-10c-.2 0-.4.2-.4.4s.2.4.4.4h10c.9 0 1.7-.7 1.9-1.6l1.4-6.1c.1-.4 0-.9-.3-1.2zM9.369 16.999c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3.1c-.6 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2.6 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2zM18.369 16.999c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3.1c-.6 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2.6 0 1.2.5 1.2 1.2-.1.7-.6 1.2-1.2 1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "basket_svg__st1",
    d: "M19.869 14.999h-12l-1.1-4.4-2.2-9.4c-.1-.6-.6-.9-1.2-.9h-2.7c-.2 0-.4.2-.4.4-.1.3.1.4.4.4h2.8c.2 0 .3.1.4.3l2 8.9v.1l.1.5 1.2 4.7c0 .2.2.3.4.3h12.2c.2 0 .4-.2.4-.4s0-.5-.3-.5z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "basket_svg__st2 basket_svg__st3",
    style: {
      whiteSpace: "pre",
      fontSize: "9.1px",
      fill: "#fff"
    },
    x: 11.991,
    y: 10.543
  }, "+"), /*#__PURE__*/React.createElement("text", {
    className: "basket_svg__st1 basket_svg__st2 basket_svg__st3",
    style: {
      whiteSpace: "pre",
      fontSize: "9.1px"
    },
    x: 11.991,
    y: 10.543
  }, "+"));
};
export default SvgBasket;